export default function GS_Sort() {
  return (
    <div className="p-4">
      <h1>GS Sort</h1>
    </div>
  );
}
